import { render, staticRenderFns } from "./GetIP.vue?vue&type=template&id=449f0cea&scoped=true&"
import script from "./GetIP.vue?vue&type=script&lang=js&"
export * from "./GetIP.vue?vue&type=script&lang=js&"
import style0 from "./GetIP.vue?vue&type=style&index=0&id=449f0cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f0cea",
  null
  
)

export default component.exports